(() => {
  function onChangeSort(e){
    const el = e.target;
    if(!el.matches('[data-shampo-sort]')) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', el.value);
    // paginationリセット
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  document.addEventListener('change', onChangeSort);
})();